import ArchiveWinnerCategory from './Main'
import { getBaseMetaTitle } from '@/environments'

const route = {
  path: '/archive/winner/:year/:categoryName',
  name: 'winnerArchiveCategory',
  meta: {
    title: `Archive - ${getBaseMetaTitle}`
  },
  component: ArchiveWinnerCategory
}

export default route
